import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=442353d4&scoped=true"
import script from "./Bind.vue?vue&type=script&lang=js"
export * from "./Bind.vue?vue&type=script&lang=js"
import style0 from "./Bind.vue?vue&type=style&index=0&id=442353d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442353d4",
  null
  
)

export default component.exports